import { useState, useCallback } from 'react';
import { authApi } from '@/sdk/shared';
import type { LoginRequest, LoginResponse, ApiError } from '../types';

interface UseLoginReturn {
  login: (data: LoginRequest) => Promise<LoginResponse>;
  isLoading: boolean;
  error: ApiError | null;
  clearError: () => void;
}

export const useLogin = (): UseLoginReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);

  const login = useCallback(async (data: LoginRequest): Promise<LoginResponse> => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await authApi.login(data);
      return response;
    } catch (err) {
      const error = err as ApiError;
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    login,
    isLoading,
    error,
    clearError,
  };
};
